import { Card, Text } from '@lbcamden/lib-react';
import { sentenceCase } from '@lbcamden/shared-utils';
import { FunctionComponent } from 'react';

import { api } from '~/client/lib/trpc';

import { StatCardsContainer, StatCount, TopLevelStatsRoot } from './TopLevelStats.styled';

type Props = {
  dateRange?: [string, string];
};

export const TopLevelStats: FunctionComponent<Props> = ({ dateRange }) => {
  const { data } = api.activityReportStats.useQuery({ dateRange });

  return (
    <TopLevelStatsRoot>
      <Text variant="h4">Top level statistics</Text>
      <StatCardsContainer>
        {data &&
          Object.entries(data).map(([key, count]) => (
            <Card key={key}>
              <Text $color="textSecondary" $weight={500}>
                {sentenceCase(key)}
              </Text>
              <StatCount>{count}</StatCount>
            </Card>
          ))}
      </StatCardsContainer>
    </TopLevelStatsRoot>
  );
};
